import request from "@/utils/request";

// 查询当前用户空间情况
export function getImInfo(params, config) {
    return request.get(`/im/api/account/getImInfo`, params, config)
}